import {createSvgIcon} from '@yandex-delivery/blocks/icons/utils'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import React from 'react'

const className = css`
  inline-size: ${spacing(10.75)};
  block-size: ${spacing(10.625)};
`
export default createSvgIcon(
  <svg
    className="footer__icon icon-arr"
    fill="none"
    height="86"
    viewBox="0 0 87 86"
    width="87"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M86 43C86 66.1851 66.983 85 43.5 85C20.017 85 1 66.1851 1 43C1 19.8149 20.017 1 43.5 1C66.983 1 86 19.8149 86 43Z"
      fill="#252525"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M36.4377 59.1237L18.0391 59.1237V27.8656L36.4377 27.8656V16.2246L76.9282 44.1413L36.4377 72.0581V59.1237Z"
      fill="white"
    />
  </svg>,
  'ArrowCircle',
  {viewBox: '0 0 87 86', className},
)
